module.exports = __webpack_public_path__ + "static/img/role.ad3ccdb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/menu/role.png
// module id = Qomh
// module chunks = 58